// extracted by mini-css-extract-plugin
export var dataCell = "_rm-2";
export var dataRow = "_rm-0";
export var headerRow = "_rm-1";